import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornmentComponent from '../Input-adornment/Input-adornment.component';
import useDictionary from '@ui/hooks/useDictionary';
import ListComponent from './List.component';
import { variants } from './variants.enum';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    description,
    disabled,
    id,
    helperText,
    label,
    name,
    value,
    values,
    variant,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
}) => {
    const getWord = useDictionary();

    let autocompleteClass = 'autocomplete';
    switch (variant) {
        case variants.sidebar:
            autocompleteClass = 'autocomplete_sidebar';
            break;
    }

    return (
        <>
            <Autocomplete
                classes={{
                    root: autocompleteClass,
                    option: 'autocomplete__item',
                    noOptions: 'autocomplete__item',
                    inputRoot: 'autocomplete__input-field',
                    popper: 'autocomplete__popper',
                }}
                disabled={disabled}
                size="small"
                freeSolo
                id={id}
                options={values ?? []}
                ListboxComponent={ListComponent}
                renderInput={(params) => {
                    let InputProps = params.InputProps;
                    if (description) {
                        InputProps.startAdornment = (
                            <InputAdornmentComponent
                                lang={lang}
                                data={description}
                            />
                        );
                    }

                    return (
                        <TextField
                            {...params}
                            className="autocomplete__input"
                            helperText={
                                helperText ? getWord(helperText) : undefined
                            }
                            label={label ? getWord(label) : undefined}
                            name={name}
                            InputProps={InputProps}
                        />
                    );
                }}
                value={value}
                onInputChange={onChange}
                onClick={onClick}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
            />
        </>
    );
};

const AutocompleteComponent = React.memo(Component);

export default AutocompleteComponent;
